// Delegated handler for variant switching inside the Quick Buy drawer
(() => {
  // Avoid double-binding
  if (window.__dsQuickBuyBound) return;
  window.__dsQuickBuyBound = true;

  const preloadDrawer = (drawer) => {
    if (!drawer || typeof drawer.preload !== "function") return;

    const handles = Array.from(
      drawer.querySelectorAll(".ds-product-quick-buy__variant[data-product-handle][data-variant-id]")
    ).map(
      (option) =>
        `${option.getAttribute("data-product-handle")}?variant=${option.getAttribute("data-variant-id")}`
    );

    drawer.preload(handles);
  };

  const renderPreview = (drawer, option) => {
    const preview = option.querySelector(".ds-product-quick-buy__preview");
    const currentHeader = drawer.querySelector('[slot="header"]');
    const previewHeader = preview?.content.firstElementChild?.cloneNode(true);

    if (currentHeader && previewHeader) currentHeader.replaceWith(previewHeader);

    // The product can already be submitted while its full Quick Buy HTML finishes loading.
    const variantInput = drawer.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (variantInput) variantInput.value = option.getAttribute("data-variant-id");
  };

  // Warm the first product response before the drawer is opened when a customer points at the trigger.
  ["pointerover", "focusin"].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const control = event.target.closest("[aria-controls]");
      if (!control) return;

      const drawer = document.getElementById(control.getAttribute("aria-controls"));
      if (drawer?.matches("quick-buy-drawer") && typeof drawer.preload === "function") {
        drawer.preload([drawer.getAttribute("handle")]);
      }
    });
  });

  // Drawer content is injected asynchronously. Once it exists, preload every product shown in its cards.
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        const drawer = node.matches("quick-buy-drawer")
          ? node
          : node.closest("quick-buy-drawer");
        if (drawer && node.querySelector?.(".ds-product-quick-buy__variants")) preloadDrawer(drawer);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target.closest(".ds-product-quick-buy__variant");
      if (!target) return;

      // Prevent anchor default
      event.preventDefault();

      const drawer = target.closest("quick-buy-drawer");
      if (!drawer) return;

      const handle = target.getAttribute("data-product-handle");
      const variantId = target.getAttribute("data-variant-id");
      if (!handle || !variantId) return;

      // Skip if nothing changes
      const nextHandle = `${handle}?variant=${variantId}`;
      if (drawer.getAttribute("handle") === nextHandle) return;

      renderPreview(drawer, target);

      // Update selected styling
      const container = target.closest(".ds-product-quick-buy__variants");
      if (container) {
        container
          .querySelectorAll(".ds-product-quick-buy__variant.is-selected")
          .forEach((el) => el.classList.remove("is-selected"));
        target.classList.add("is-selected");
      }

      // Update drawer handle to fetch the new product/variant content
      drawer.setAttribute("handle", nextHandle);

      // Force reload of content
      try {
        if (typeof drawer._hasLoaded !== "undefined") {
          drawer._hasLoaded = false;
        }
        // Reload immediately to reflect the new selection
        if (typeof drawer.show === "function") {
          drawer.show();
        }
      } catch (e) {
        console.warn("[ds-quick-buy] Could not reload drawer:", e);
      }
    },
    true
  );
})();
